import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, reactive, watch, onMounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminManageRunsPage } from '@Integrations/Runs/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminManageRunsPage',
  setup(__props) {

    document.title = "Manage runs"

    const tid = useOrganizationUnitId()

    const { useCurrentUserQuery, useRunsOfOrganizationQuery } = useAdminManageRunsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelRunsOfOrganizationQueryV1, runRunsOfOrganizationQueryV1 } = useRunsOfOrganizationQuery(tid)
    const runs = computed(() => modelRunsOfOrganizationQueryV1.value?.Runs || [])

    onMounted(() => {
        runCurrentUserQueryV1()
        runRunsOfOrganizationQueryV1()
    })

return { __sfc: true,tid, useCurrentUserQuery, useRunsOfOrganizationQuery, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, modelRunsOfOrganizationQueryV1, runRunsOfOrganizationQueryV1, runs }
}

})